import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const SessionStartBV = observer(class SessionStartBV extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.checkTime = this.checkTime.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1
    }

    const { examSid, sessionSid } = this.props;

    this.props.store.ExamStore.getExam(examSid);
    this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.checkTime);
    this.props.store.SessionStore.getCurrentTime();
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  checkTime() {
    const { examSession } = this.props.store.ExamStore;
    const now = moment(this.props.store.SessionStore.currentTime);
    const sessionTime = moment(examSession.appointmentDate);
    const timeToSession = moment.duration(sessionTime.diff(now)).asMinutes();

    if(timeToSession < -30) {
      this.setState({
        step: 5
      });
    } else if(timeToSession > 30) {
      this.setState({
        step: 4
      });
    }
  }

  render() {
    const { store, translation } = this.props;
    const { ExamStore, SessionStore } = store;
    const { exam, examSession } = ExamStore;
    const { profile, userTimezone } = this.props.store.SessionStore;
    const proctorManagerUrl = encodeURIComponent('https://app.smarterproctoring.com/#/bvirtual-manager');

    let launchURL = 'https://smarterservices.onlineproctornow.com/api/start_session.ns';
    launchURL += `?issue_menu=1`;
    launchURL += `&id=14`;
    launchURL += `&external_key=${examSession.sid}-SmarterProctoring`;
    launchURL += `&customer_name=${SessionStore.profile.firstName.replace('#', '')} ${SessionStore.profile.lastName.replace('#', '')}`;
    launchURL += `&customer_company=${SessionStore.userData.installSid}`;
    launchURL += `&customer_desc=${SessionStore.courseData.title.replace('#', '')} | ${exam.title.replace('#', '')}`;
    launchURL += `&session.custom.proctor_manager_url=${proctorManagerUrl}`;
    launchURL += `&session.custom.access_key=${examSession.accessKey}`;
    launchURL += `&session.custom.email=${profile.email}`

    if(!SessionStore.loading && exam && examSession.examConfiguration) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(1)}`}>
              <h2 className="panel__title">{translation.confirm.heading}</h2>

              <ul className="data--alt">
                <li>
                  <strong className="subtitle">{translation.confirm.title}</strong>
                  <p>{exam.title}</p>
                </li>
                <li>
                  <strong className="subtitle">{translation.confirm.session_date}</strong>
                  <p>{moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</p>
                </li>
                <li>
                  <strong className="subtitle">{translation.confirm.duration}</strong>
                  <p>{toHours(examSession.examConfiguration.duration, false, false, false)}</p>
                </li>
              </ul>

              <button className="btn" onClick={(e) => {this.nextStep(e)}}>
                {translation.continue}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(2)}`}>
              <h2 className="panel__title">{translation.test.heading}</h2>

              <p>{translation.test.body}</p>

              <a className="panel__link--alt" href="https://onlineproctornow.com/systemtest.php" target="_blank">{translation.test.link}</a>

              <button
                className="btn" onClick={(e) => {this.nextStep(e)}}
              >
                {translation.continue}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(3)}`}>
              <h2 className="panel__title">{translation.download.heading}</h2>

              <p>{translation.download.body}</p>

              <a
                className="btn"
                href={launchURL}
              >
                <icons.iconDownload />
                {translation.download.button}
              </a>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(4)}`}>
              <h2 className="panel__title">{translation.early.heading}</h2>

              <p>{translation.early.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <a className="panel__link--alt" href="https://onlineproctornow.com/systemtest.php" target="_blank">{translation.test.link}</a>

              <button
                className="btn"
                onClick={(e) => {closeDrawer(e, this.props.parent)}}
              >
                {translation.early.button}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(5)}`}>
              <h2 className="panel__title">{translation.late.heading}</h2>

              <p>{translation.late.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <button
                className="btn"
                onClick={(e) => {closeDrawer(e, this.props.parent)}}
              >
                {translation.late.button}
              </button>
            </div>
          </div>
        </div>
      )
    }

    return null
  }
})

export default translate('SessionStartBV')(SessionStartBV);


// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/SessionStartBV.js